import RequestMaster from '../RequestMaster'

export default class RequestEmpleado extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/empleado'
    }


    /**
     * Hace el logueo del responsable
     *
     * @param {FormData} params
     * @param {Function} callback
     * @param {Function} callbackError
     * @param {Function} callbackFinally
     */
    search(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = ""
        this.get(path, params, callback, callbackError, callbackFinally)
    }
}
